import { render, staticRenderFns } from "./joinus.vue?vue&type=template&id=7afd3b98&"
import script from "./joinus.vue?vue&type=script&lang=js&"
export * from "./joinus.vue?vue&type=script&lang=js&"
import style0 from "./joinus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports